import React from 'react'
import Sequencer from './utilities/Sequencer';

// the module is the actual box the course lives in
// this layer represents the 'learner view'

const Module = props => {

    return (
        <div className="Module">
            {/* <pre>
                Location:{JSON.stringify(props.currentLocation)}
            </pre> */}

            {/* Header */}
            <div className="Header"> 
                <div className={`logo ${props.invertLogo ? 'invert' : ''}`}></div>
            </div>

            {/* Global Nav */}
           
            {/* Main Content area */}
            <div className={`content`}>
                <Sequencer 
                    contentData={props.contentData}
                    globals={props.contentData.globals}
                    resetSco={props.resetSco}
                    invertLogo={props.invertLogo}
                    resetIndex={props.resetIndex}
                    moduleData={props.moduleData}
                    currentLocation={props.currentLocation}
                    currentBreadCrumb={props.currentBreadCrumb}
                    setCurrentLocation={props.setCurrentLocation}
                    setLocationValue={props.setLocationValue}
                    markSegmentComplete={props.markSegmentComplete}
                    progress={props.progress}
                    setEditorShortcut={props.setEditorShortcut}
                    setLocationValues={props.setLocationValues}
                    isLocalHost={props.isLocalHost}
                    setQuit = {props.setQuit}
                />
            </div>
            {/* Footer */}
            <div className={`Footer`}></div>
        </div>
    )
}

export default Module